// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".padded[data-v-5cfbc23b]{padding:20px}.statistic[data-v-5cfbc23b]{overflow-y:scroll;height:600px}.comment[data-v-5cfbc23b]{width:500px}", ""]);
// Exports
module.exports = exports;
